export const AffiliateSkeleton = () => (
    <div className="loading-container">
        <div className="loading-element loading-header" />
        <div className="loading-element loading-content" />
        <div className="loading-element loading-content" />
    </div>
);
export default AffiliateSkeleton;
